import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, SubscriptionLike } from 'rxjs';
import { CONFIG } from 'src/helper/app-config';
import {
  GetPlanogramBodyParams,
  PlanogramSegmentEntityModal,
  ScreenDataModal,
  planogramsModel,
} from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog } from '@angular/material/dialog';
import { all_planograms } from 'src/helper/static';
import { ConfirmDialogModalComponent } from '../confirm-dialog-modal/confirm-dialog-modal.component';
import { ComparePlanogramDialogComponent } from '../compare-planogram-dialog/compare-planogram-dialog.component';
import { CopyPlanogramDialogComponent } from '../copy-planogram-dialog/copy-planogram-dialog.component';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';
import { PlanogramService } from 'src/services/planogram.service';
import { environment } from 'src/environments/environment';

interface Planogram {
  channel: string;
  cooler_type: string;
  unit: string;
  planogram_image_uri: string;
  update_available: number;
  updated_at: Date;
  id: number;
}

@Component({
  selector: 'app-planogram-list',
  templateUrl: './planogram-list.component.html',
  styleUrls: ['./planogram-list.component.css'],
})
export class PlanogramListComponent implements OnInit {
  CONFIG = CONFIG;

  saved_planogram: Observable<planogramsModel> =
    this.planogramState.all_planogram;
  loader: Observable<boolean> = this.planogramState.loader;
  isUserAdmin: number;
  is_more_planogram_observable: Observable<boolean> =
    this.planogramState.is_more_planograms;
  screen_data: Observable<ScreenDataModal[]> =
    this.planogramState.specific_screen_data;

  saved_planogram_subscription: SubscriptionLike;
  is_more_planogram_subscription: SubscriptionLike;
  screen_data_subscription: SubscriptionLike;

  tabs = [
    { name: 'Published', path: '../' + CONFIG.PATH.PUBLISHED },
    { name: 'Drafts', path: '../' + CONFIG.PATH.DRAFT },
  ];
  active_tab = this.tabs[1].name;
  displayedColumnsForAdmin: string[] = [
    'name',
    'unit',
    'channel',
    'cooler_type',
    'cooler_value',
    'created_at',
    'created_by',
    'progress_status',
    'action',
  ];
  displayedColumnsForUser: string[] = [
    'name',
    'unit',
    'channel',
    'cooler_type',
    'cooler_value',
    'created_at',
    'progress_status',
    'action',
  ];
  search_input = '';
  is_show_loader = false;
  is_more_planogram = true;
  planogram_limit: number;
  planogram_list: any;
  planogram_list_form_group: FormGroup;
  filtered_planogram_list: any;
  selectionSequence = [
    'planogram_name',
    'unit',
    'channel',
    'cooler_type',
    'created_at',
    'status',
  ];
  // selectedOptions:{[key:string]:string[]}={planogram_name:[],unit:[],channel:[],cooler_type:[],created_at:[],status:[]}
  planogramNames: string[];
  units: string[];
  channels: string[];
  coolerTypes: string[];
  createdDates: string[];
  status: string[];
  pageSize: number = 8;
  pageIndex: number = 0;
  start: number = 0;
  end: number = this.pageSize;

  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  new_channels: string[] = [];
  new_coolerTypes: string[] = [];
  new_units: string[] = [];

  selectedChannels: string[] = [];
  selectedCoolerTypes: string[] = [];
  selectedUnits: string[] = [];

  planograms: any[] = [];
  filteredPlanograms: any[] = [];

  allChannelsSelected: boolean = false;
  allCoolerTypesSelected: boolean = false;
  allUnitsSelected: boolean = false;

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private _formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private planogramState: PlanogramStateService,
    public dialog: MatDialog,
    private apiService: PlanogramService
  ) {
    this.planogram_limit = document.cookie.split('planogram_limit=')[1]
      ? Number(document.cookie.split('planogram_limit=')[1])
      : 0;
    // if(!this.planogram_limit){
    //   // this.planogramState.getSpecificScreenData(['planogram_limit'])
    //   // this.planogramState.getSpecificScreenData(['brandchartcolor' , 'categorychartcolor'])
    // }else{
    //   // this.planogramState.getSpecificScreenData(['brandchartcolor' , 'categorychartcolor'])
    //   let body_params: GetPlanogramBodyParams = { limit: this.planogram_limit, offset: 0 , search: '', status:'all'}
    //   this.planogramState.getAllPlanograms(body_params);
    // }
    let body_params: GetPlanogramBodyParams = {
      limit: this.planogram_limit,
      offset: 0,
      search: '',
      status: 'all',
    };
    this.planogramState.getAllPlanograms();
    this.activatedRoute.params.subscribe((params) => {
      this.active_tab =
        params['planogram_status'] === 'published'
          ? this.tabs[0].name
          : this.tabs[1].name;
    });

    this.planogram_list_form_group = this._formBuilder.group({
      planogram_name: new FormControl({ value: [], disabled: false }),
      unit: new FormControl({ value: [], disabled: false }),
      channel: new FormControl({ value: [], disabled: false }),
      cooler_type: new FormControl({ value: [], disabled: false }),
      created_at: new FormControl({ value: [], disabled: false }),
      status: new FormControl({ value: [], disabled: false }),
    });
  }

  ngOnInit(): void {
    sessionStorage.setItem('mode', 'edit');
    this.saved_planogram_subscription = this.saved_planogram.subscribe(
      (data: any) => {
        if (data) {
          // let planograms: any[] = pl.planograms;
          // this.isUserAdmin = pl.admin_flag;
          // localStorage.setItem('admin_flag', this.isUserAdmin.toString());
          // let data = Object.values(planograms).sort(
          //   (a, b) =>
          //     new Date(b.last_edited_date).getTime() -
          //     new Date(a.last_edited_date).getTime()
          // );
          if (this.is_show_loader) {
            setTimeout(() => {
              this.is_show_loader = false;
            }, 1);
          }
          let temp_data = data.map((d: any) => {
            if (d.planogram_image_uri.includes(environment.picturesAccount)) {
              this.apiService
                .fetchImageFromBlob(d.planogram_image_uri)
                .subscribe({
                  next: (res: any) => {
                    const imageUrl = URL.createObjectURL(res);
                    d.imageUrl = imageUrl;
                  },
                  error: (error: any) => {
                    console.log('Error fetching image:', error);
                  },
                });
            } else d.image_url = '';
            return d
          });
          this.planograms = temp_data;

          this.initializeFilters();
          // this.getUniqueColumnValues(data, 0);
        }
      }
    );
    // this.is_more_planogram_subscription =
    //   this.is_more_planogram_observable.subscribe((is_more) => {
    //     this.is_more_planogram = is_more;
    //   });
    this.listenScreenConfig();
    // this.filterPlanograms();
  }

  ngOnDestroy() {
    // this.is_more_planogram_subscription.unsubscribe();
    // this.saved_planogram_subscription.unsubscribe();
  }

  // ngAfterViewInit() {
  //   this.dataSource.filterPredicate = (data: any, filter) => {
  //     let busniss_objectives = this.getAllBusinessObjectives(
  //       data.business_objective
  //     );

  //     return (
  //       data.name.toLowerCase().includes(filter) ||
  //       data.channel.toLowerCase().includes(filter) ||
  //       // data.sub_channel.value.toLowerCase().includes(filter) ||
  //       // busniss_objectives.toLowerCase().includes(filter) ||
  //       data.unit.toLowerCase().includes(filter) ||
  //       data.cooler_type.toLowerCase().includes(filter) ||
  //       data.user_name?.toLowerCase().includes(filter) ||
  //       data.progress_status.toLowerCase().includes(filter)
  //     );
  //   };

  //   this.dataSource.sortingDataAccessor = (item: any, property) => {
  //     switch (property) {
  //       case 'channel':
  //       case 'sub_channel': {
  //         return item[property].value;
  //       }

  //       case 'business_objective': {
  //         return this.getAllBusinessObjectives(item[property]);
  //       }

  //       case 'date':
  //       case 'last_edited_date': {
  //         let newDate = new Date(item[property]);
  //         return newDate;
  //       }
  //       case 'name':
  //       case 'status':
  //       case 'user_name':
  //       default: {
  //         return item[property];
  //       }
  //     }
  //   };

  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.paginator._intl.firstPageLabel = ''
  //   this.dataSource.paginator._intl.nextPageLabel = ''
  //   this.dataSource.paginator._intl.previousPageLabel = ''
  // }

  listenScreenConfig = () => {
    this.screen_data_subscription = this.screen_data.subscribe((sc) => {
      let chart_color_config = {};
      sc.forEach((ob) => {
        if (ob.key === 'brandchartcolor' || ob.key === 'categorychartcolor') {
          chart_color_config = {
            ...chart_color_config,
            ...{ [ob.key]: JSON.parse(ob.value) },
          };
        }
        if (ob.key === 'planogram_limit') {
          this.planogram_limit = Number(ob.value);
          document.cookie = `planogram_limit=${this.planogram_limit}`;
          let body_params: GetPlanogramBodyParams = {
            limit: this.planogram_limit,
            offset: 0,
            search: '',
            status: 'all',
          };
          this.planogramState.getAllPlanograms();
        }
      });
      if (Object.keys(chart_color_config).length > 0) {
        this.planogramState.setChartColorConfig(chart_color_config);
      }
    });
  };

  getAllBusinessObjectives = (business_ob: PlanogramSegmentEntityModal[]) => {
    let busniss_objectives = '';
    if (business_ob) {
      business_ob.forEach((ob, i) => {
        busniss_objectives += ob.value;
        if (i !== business_ob.length - 1) {
          busniss_objectives += ' , ';
        }
      });
    }
    return busniss_objectives;
  };

  paginationChange(pageEvt: PageEvent) {
    // if(this.is_more_planogram && pageEvt.pageIndex > pageEvt.previousPageIndex!){
    //   let body_params: GetPlanogramBodyParams = { limit: this.planogram_limit, offset: pageEvt.length, search: '', status:'all'}
    //   this.planogramState.getAllPlanograms( false);
    // }
    this.start = pageEvt.pageIndex * this.pageSize;
    this.end = this.start + this.pageSize;
    this.pageIndex = pageEvt.pageIndex;
    this.dataSource.data = this.filtered_planogram_list.slice(
      this.start,
      this.end
    );
  }

  getUniqueColumnValues(data: any, index: number) {
    let planogramNames: { [key: string]: number } = {};
    let units: { [key: string]: number } = {};
    let channels: { [key: string]: number } = {};
    let cooler_types: { [key: string]: number } = {};
    let createdDates: { [key: string]: number } = {};
    let status: { [key: string]: number } = {};
    data.forEach((v: any) => {
      if (!channels[v.channel]) {
        channels[v.channel] = 1;
      }
      if (!planogramNames[v.name]) {
        planogramNames[v.name] = 1;
      }
      if (!cooler_types[v.cooler_type]) {
        cooler_types[v.cooler_type] = 1;
      }
      if (!units[v.unit]) {
        units[v.unit] = 1;
      }
      if (!createdDates[v.created_at]) {
        createdDates[v.created_at] = 1;
      }
      if (!status[v.progress_status]) {
        status[v.progress_status] = 1;
      }
    });
    if (index == 0)
      this.planogramNames = ['All', ...Object.keys(planogramNames)];
    if (index <= 1) this.units = ['All', ...Object.keys(units)];
    if (index <= 2) this.channels = ['All', ...Object.keys(channels)];
    if (index <= 3) this.coolerTypes = ['All', ...Object.keys(cooler_types)];
    if (index <= 4) this.createdDates = ['All', ...Object.keys(createdDates)];
    if (index <= 5) this.status = ['All', ...Object.keys(status)];
    this.setInitialSelection(index);
  }

  toggleSelection(name: string, formName: string, index: number) {
    const optionsMap: Record<string, any[]> = {
      planogram_name: this.planogramNames,
      unit: this.units,
      channel: this.channels,
      cooler_type: this.coolerTypes,
      created_at: this.createdDates,
      status: this.status,
    };

    const options = optionsMap[formName] || [];
    const control = this.planogram_list_form_group.controls[formName];
    const currentValue = control?.value || [];

    if (name === 'All') {
      if (!currentValue.includes('All')) {
        control?.setValue([]);
        this.onfilterChange(index, formName);
        return;
      }

      this.selectionSequence.slice(index).forEach((v) => {
        this.planogram_list_form_group.controls[v]?.setValue(options);
      });
      this.onfilterChange(index, formName);
      return;
    }

    if (!currentValue.includes(name) && currentValue.includes('All')) {
      control?.setValue(options.filter((v) => v !== 'All' && v !== name));
    }

    this.selectionSequence.slice(index + 1).forEach((v) => {
      this.planogram_list_form_group.controls[v]?.setValue(options);
    });

    this.onfilterChange(index, formName);
  }

  onfilterChange(index: number, formName: string) {
    let selectedChannel =
      this.planogram_list_form_group.controls['channel'].value;
    let selectedPlanogramName =
      this.planogram_list_form_group.controls['planogram_name'].value;
    let selectedUnit = this.planogram_list_form_group.controls['unit'].value;
    let selectedCoolerType =
      this.planogram_list_form_group.controls['cooler_type'].value;
    let selectedCreatedDates =
      this.planogram_list_form_group.controls['created_at'].value;
    let selectedStatus =
      this.planogram_list_form_group.controls['status'].value;
    if (formName == 'planogram_name' && selectedPlanogramName.includes('All')) {
      this.filtered_planogram_list = this.planogram_list;
      this.dataSource.data = this.filtered_planogram_list.slice(
        0,
        this.pageSize
      );
      this.getUniqueColumnValues(this.filtered_planogram_list, 0);
    } else {
      this.filtered_planogram_list = this.planogram_list.filter(
        (v: any) =>
          (!selectedPlanogramName.includes('All') &&
          selectedPlanogramName.length !== 0
            ? selectedPlanogramName.includes(v['name'])
            : true) &&
          (!selectedChannel.includes('All') && selectedChannel.length !== 0
            ? selectedChannel.includes(v['channel'])
            : true) &&
          (!selectedUnit.includes('All') && selectedUnit.length !== 0
            ? selectedUnit.includes(v['unit'])
            : true) &&
          (!selectedCoolerType.includes('All') &&
          selectedCoolerType.length !== 0
            ? selectedCoolerType.includes(v['cooler_type'])
            : true) &&
          (!selectedCreatedDates.includes('All') &&
          selectedCreatedDates.length !== 0
            ? selectedCreatedDates.includes(v['created_at'])
            : true) &&
          (!selectedStatus.includes('All') && selectedStatus.length !== 0
            ? selectedStatus.includes(v['progress_status'])
            : true)
      );
      this.dataSource.data = this.filtered_planogram_list.slice(
        0,
        this.pageSize
      );
      this.getUniqueColumnValues(this.filtered_planogram_list, index + 1);
    }
    this.pageIndex = 0;
    this.start = 0;
    this.end = this.pageSize;
  }

  setInitialSelection(index: number) {
    let sequence = [
      this.planogramNames,
      this.units,
      this.channels,
      this.coolerTypes,
      this.createdDates,
      this.status,
    ];
    this.selectionSequence.forEach((dropdown, i) => {
      if (index == 0 || (i >= index && i < this.selectionSequence.length))
        this.planogram_list_form_group.controls[dropdown]?.setValue(
          sequence[i]
        );
    });
  }

  updateFilter = (_event: any) => {
    //this.dataSource.filter = this.search_input.trim().toLowerCase();
    let fiterTerm = this.search_input.trim().toLowerCase();
    this.filtered_planogram_list =
      fiterTerm.length == 0
        ? this.planogram_list.slice()
        : this.planogram_list
            .slice()
            .filter(
              (data: any) =>
                data.name.toLowerCase().includes(fiterTerm) ||
                data.channel.toLowerCase().includes(fiterTerm) ||
                data.unit.toLowerCase().includes(fiterTerm) ||
                data.cooler_type.toLowerCase().includes(fiterTerm) ||
                data.user_name?.toLowerCase().includes(fiterTerm) ||
                data.progress_status.toLowerCase().includes(fiterTerm)
            );
    this.dataSource.data = this.filtered_planogram_list.slice(
      this.start,
      this.end
    );
  };

  addNewPlanogram = () => {
    this.router.navigateByUrl(CONFIG.PATH.NEWPLANOGRAM);
  };

  openAdminPanel = () => {
    this.router.navigateByUrl(CONFIG.PATH.ADMINPANEL);
  };

  handleRowClick = (row: any) => {
    let router_state = {
      screen_index: row.screen_id ? row.screen_id - 1 : 0,
    };
    this.router.navigateByUrl(CONFIG.PATH.PLANOGRAM + row.id, {
      state: router_state,
    });
    //this.planogramState.getPlanogramSavedData(row.id);
  };

  copyPlanogram = (
    event: any,
    planogram_id: number,
    planogram_name: string
  ) => {
    event.stopPropagation();
    this.dialog.open(CopyPlanogramDialogComponent, {
      height: '200px',
      width: '500px',
      data: {
        planogram_id: planogram_id,
        planogram_name: planogram_name,
      },
    });
  };

  handleDeleteClick = (event: any, planogram_id: number) => {
    event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogModalComponent, {
      height: '200px',
      width: '500px',
      data: {
        header_msg: 'Are you sure you want to delete?',
        header_msg_description: 'This action cannot be undone.',
        cancel_action: 'Cancel',
        ok_action: 'Continue',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (planogram_id !== undefined) {
          this.planogramState.deletePlanogram(planogram_id);
        }
      }
    });
  };

  // addCoolerTemplate = () => {
  //   this.dialog.open(CreateCoolerTemplateDialogComponent, {
  //     height: '800px',
  //     width: '1000px',
  //   });
  // };

  openComparePlanogramDialog = () => {
    this.dialog.open(ComparePlanogramDialogComponent, {
      height: '90%',
      width: '95%',
      maxWidth: '95vw',
      data: {
        planogram_ids: [],
      },
    });
  };

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  initializeFilters() {
    this.planograms.forEach((element: any) => {
      if (!this.new_channels.includes(element.channel)) {
        this.new_channels.push(element.channel);
      }
      if (!this.new_coolerTypes.includes(element.cooler_type)) {
        this.new_coolerTypes.push(element.cooler_type);
      }
      if (!this.new_units.includes(element.unit)) {
        this.new_units.push(element.unit);
      }
    });

    this.selectedChannels = [...this.new_channels];
    this.selectedCoolerTypes = [...this.new_coolerTypes];
    this.selectedUnits = [...this.new_units];

    this.updateSelectAllStatus();
    this.filterPlanograms();
  }

  filterPlanograms() {
    this.filteredPlanograms = this.planograms.filter((planogram) =>
      this.filterCondition(planogram)
    );
  }

  filterCondition(planogram: any): boolean {
    return (
      this.selectedChannels.includes(planogram.channel) &&
      this.selectedCoolerTypes.includes(planogram.cooler_type) &&
      this.selectedUnits.includes(planogram.unit)
    );
  }

  toggleAllChannels() {
    this.allChannelsSelected = !this.allChannelsSelected;
    this.selectedChannels = this.allChannelsSelected
      ? [...this.new_channels]
      : [];
    this.filterPlanograms();
  }

  toggleAllCoolerTypes() {
    this.allCoolerTypesSelected = !this.allCoolerTypesSelected;
    this.selectedCoolerTypes = this.allCoolerTypesSelected
      ? [...this.new_coolerTypes]
      : [];
    this.filterPlanograms();
  }

  toggleAllUnits() {
    this.allUnitsSelected = !this.allUnitsSelected;
    this.selectedUnits = this.allUnitsSelected ? [...this.new_units] : [];
    this.filterPlanograms();
  }

  updateSelectAllStatus() {
    this.allChannelsSelected =
      this.selectedChannels.length === this.new_channels.length;
    this.allCoolerTypesSelected =
      this.selectedCoolerTypes.length === this.new_coolerTypes.length;
    this.allUnitsSelected = this.selectedUnits.length === this.new_units.length;
  }

  onSelectionChange() {
    this.updateSelectAllStatus();
    this.filterPlanograms();
  }

  moveToGuidelines(planogramData: any) {
    this.router.navigateByUrl(CONFIG.PATH.GUIDELINES_INPUT + planogramData.id, {
      state: { screen: 'library' },
    });
  }

  moveToReview(planogramData: any) {
    this.router.navigateByUrl(CONFIG.PATH.PLANOGRAM + planogramData.id, {
      state: {
        screen_index: planogramData.screen_id ? planogramData.screen_id - 1 : 2,
        from: 'library',
      },
    });
  }

  updatePlanogram(planogramData: any) {
    let payload: any = {};
    payload.channel = planogramData.channel?.trim();
    payload.unit = planogramData.unit;
    payload.cooler_type = planogramData.cooler_type;
    payload.npd_selection = planogramData.npd_selection;
    this.planogramState.createBasePlanogram(payload);
    //this.planogramState.updatePlanogram(payload)
    //this.moveToReview(planogramData)
  }

  showVerticalLine(index: number): boolean {
    const pattern = [1, 2];
    const modIndex = index % 3;
    return pattern.includes(modIndex);
  }
}
